import { isMobile } from "../../scripts/helpers";

export default class TopicsList {
  constructor() {
    var topics = document.querySelector('.topics');

    if(!isMobile() && typeof(topics) != 'undefined' && topics != null) {
      this.topicsExpand(topics);
    }
  }

  topicsExpand(topicsContainer) {
    var topicsList = document.querySelector('.topics__list');
    var topicsExpand = document.querySelector('.topics__expand');

    topicsExpand.addEventListener('click', function() {
      var self = this;
      
      if(topicsContainer.getAttribute('style') == null) {
        self.querySelector('span').innerText = '-';
        topicsContainer.setAttribute('style', `max-height: ${topicsList.offsetHeight}px;`);
      } else {
        self.querySelector('span').innerText = '+';
        topicsContainer.removeAttribute('style');
      }
    });
  };
}

const topics = new TopicsList();